// JavaScript Document

// hide content from audiences
function showContentBlocker() {
	$('.video-wrapper').addClass("pb-0");
	$('.btn.modal__close').addClass("d-none");
	$("#VideoHolder").html("<div style='width: 100%; max-width: 700px; margin: 0 auto;'><h1 class='caslon d-block' style='line-height: normal;'>Sorry!</h1><h1 class='product-message'>This product is not currently available for delivery in your area.</h1><h1 class='account-message'>We no longer ship to your area.</h1><p class='rte pt-1'>You can find Buchi near you using our <a title='Find Buchi near you' href='/pages/store-locator'>Store Locator</a>.</p></div>");
	$('body').addClass('modal-open video-modal-open modal-open--solid');
	$('#VideoModal').addClass('modal--is-active').hide().fadeIn();
}

// contact page forms
if($('body').hasClass('contact-page')){  	
	function openContactForm() {
		$("#shopify-section-template--14198641000483__16485670384ae24e35").slideDown();
		$('html, body').animate({
        scrollTop: $("#shopify-section-template--14198641000483__16485670384ae24e35").offset().top
    }, 1300);
	}
	$("#shopify-section-template--14198641000483__16485670384ae24e35").hide(); 
	$('.form-dropdown__trigger').click( function() { 
		$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item').css('display','none');
		$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(1)').css('display','block');
		openContactForm();
	});
	$('.retailer-form__submit').click( function() {  
		let addressval = $("#retailer-zip-input").val();
		let zipval = addressval.substring(addressval.length - 5, addressval.length);
		let isnum = /^\d+$/.test(zipval);  	

		let zipsarray = ["28754","28714","28717","28657","28604","28605","28607","28655","28762","28716","28786","28779","28713","28789","28734","28741","28723","28712","28717","28774","28747","29303","29301","29307","29302","29306","29615","29662","29680","29681","29605","29611","28801","28803","28804","28805","28806","28787","28753","28786","27536","27537","28704","28711","28715","28730","28731","28732","28739","28743","28754","28773","28778","28779","28785","28790","28791","28792","29601","29607","29609","29617","29690"];
		if (isnum === true) {
			if(zipsarray.indexOf(zipval) >= 0) { 
				// DSD  
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item, #shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2) .acerill-custom-form').css('display','none');
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2), div[data-form-id="fc894470-9017-4ab6-b83e-01775c889907"]').css('display','block');
				$('div[data-form-id="fc894470-9017-4ab6-b83e-01775c889907"] input[id="3a97ac04-1cf0-4af9-bb64-1a9bb43f1b24"]').val(addressval);
				openContactForm();

			} else {
				// non-DSD
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item, #shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2) .acerill-custom-form').css('display','none');
				$('#shopify-section-template--14198641000483__16485670384ae24e35 .custom__item:nth-child(2), div[data-form-id="354c5bbf-3a92-4421-94f8-b9314b89567e"]').css('display','block');
				$('div[data-form-id="354c5bbf-3a92-4421-94f8-b9314b89567e"] input[id="3a97ac04-1cf0-4af9-bb64-1a9bb43f1b24"]').val(addressval);
				openContactForm();
			}
		}	
		});	
}	

// show pw on click
function showPass() {
  var pwinput = document.getElementById("CustomerPassword");
  if (pwinput.type === "password") {
    pwinput.type = "text";
  } else {
    pwinput.type = "password";
  }
}


// doc ready
$(document).ready(function(){	
	
// add active class to collection nav link	
let currentURL = window.location.pathname;
$('.collection-nav__item').each(function(){
  let collectionLink = $(this).attr('href');
  if (currentURL == collectionLink){
	$(this).parent().addClass('site-nav--active');
  }
}); 		
	
// SMOOTH SCROLING FOR JUMP LINKS Select all links with hashes   
// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .not('.nav-tabs__link')    
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
            }, 1300, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        });
      }
    }
  });
	
// yotpo stars text adjustment
if($('body').hasClass('template-product')){  
	let starsNumber = $('.star-clickable .text-m').text().match(/\d+/);
	$('.star-clickable .text-m').text("(" + starsNumber + ") Reviews");
}

// keg special flavor picker
if($('.keg-flavor').length){  
	var firstKegFlavor = $('.keg-list-li:first-child > .other-drinks__list-link').text();
	$('.flavor-label').text(firstKegFlavor);
}	
var otherDrinkItems = $('.keg-flavor-list .keg-list-li').click(function() {
    var kegItemIndex = otherDrinkItems.index(this) + 2;
	var kegVariantTarget = $(this).parents('.keg-sub-nav').prev().find('.variant-input-wrap .variant-input:nth-child(' + kegItemIndex + ') > input');
	var kegVariantVal = kegVariantTarget.val();
	kegVariantTarget.click();
	$('.flavor-label').text(kegVariantVal);
	$('.is--keg-flavor-btn').click();
});	


// hide products, accounts, portal from ineligible
if ( $('body').hasClass('ineligible') ) {  
	if ( $('body').hasClass("template-customers-login") || $('body').hasClass("template-customers-register") || $('body').hasClass("template-customers-account") || $('body').hasClass("template-customers-addresses") || $('body').hasClass("template-customers-order") || $('body').is("#drink-buchi") ) {
		showContentBlocker();	
	}
}

// redirect from cart page to homepage	
if($('body').is("#your-shopping-cart") ) {
	window.location.replace("https://www.drinkbuchi.com/");
}	
	
// keep autoplaying Flickity sliders on mobile scroll	
if ( $(window).width() < 769 && $( ".is--slideshow-with-columns" ).length) {
    var flkty = Flickity.data('.is--slideshow-with-columns'); 
	flkty.on( 'pointerDown', function( event, pointer ) {
		flkty.playPlayer();
	});
}

// underline account link if in account page
if($('body').is("#account") ) {
	$('.custom-account').addClass("site-nav--active");
}	

// close nav on click, for anchors and verifyer
$('.slide-nav__link, .slide-nav__sublist-link').not('.js-toggle-submenu').click( function() { 
	$('.js-toggle-slide-nav').click();
});	

// avoid double validation if entering portal after Quick Action
$('#quickactions .qa-button').click( function() {
	sessionStorage.setItem("preValidated", "true");
}); 
	
// forcing validator dropdown choice	
$('#validator-form__submit').click( function(e) {
	if ($(this).hasClass('disabled')) {
		e.preventDefault();	
		$(".validator-force-message").addClass("show");
	} else {
		$(".validator-force-message").removeClass("show");
		validateAddress();
	}

}); 

// hiding acerill branding
if ( $( ".acerill-custom-form" ).length ) { 
	let checkExist = setInterval(function() {
	if ( $('.acerill-custom-form').last().find('form').length ) {    
	// Clear interval so this only runs once
	clearInterval(checkExist);
		$(".acerill-custom-form").each(function(){
			$(this).find('div').each(function(){
			let childText = $(this).text();
			if (childText === "Powered by Acerill Forms") {
				$(this).css('left','-500000px');
			}
			});
		});	
		
	} 
	}, 100); // check every 100ms	
}

// 2024 popup
$('.js-modal-close').click( function() {
	$('.modal__inner').addClass('opacity-0');
	$('#VideoModal').fadeOut();
	$('body').removeClass('modal-open video-modal-open modal-open--solid');
	setTimeout(function(){
		$('#VideoModal').removeClass('modal--is-active');
		$('.video-wrapper iframe').remove();
	}, 400);
}); 
	
// center mode slick slider
if ($('.main-carousel').length) {
$('.main-carousel').slick({
	centerMode: true,
	centerPadding: '10%',
	slidesToShow: 1,
	arrows: false,
	pauseOnHover: false,
	autoplay: true,
  	autoplaySpeed: 7000,
	/*
	responsive: [
	{
	  breakpoint: 768,
	  settings: {
		arrows: false,
		centerMode: true,
		centerPadding: '40px',
		slidesToShow: 3
	  }
	},
	{
	  breakpoint: 480,
	  settings: {
		arrows: false,
		centerMode: true,
		centerPadding: '40px',
		slidesToShow: 1
	  }
	}
	]
	*/
});	
}

	
});	// doc ready end	


window.onload = function(){
var api = new Yotpo.API(yotpo);
api.refreshWidgets();
};
